import { Action } from '../types/state';

export function createReducer<S>(
  initialState: S,
  handlersTable: Record<string, (state: S, action: Action) => S>,
) {
  return function reducer(state = initialState, action: Action) {
    const handler = handlersTable[action.type as string];
    if (typeof handler === 'function') {
      return handler(state, action);
    }
    return state;
  };
}
